import classNames from "classnames";
import React from "react";
import Lottie from "react-lottie";
import HtmlRender from "./HtmlRender";
import Link from "next/link";
import styles from "./Service.module.css";
import { highlightText } from "./../common/highlightText";

const ServiceCardHorizontal = ({
  id,
  title,
  description,
  src,
  lottieFile,
  customSize = false,
  className,
  isHighlight,
  query,
}) => {
  const renderTitle = () => {
    if (isHighlight && query) {
      return highlightText(title, query);
    }
    return title;
  };

  const renderDescription = () => {
    if (isHighlight && query) {
      return highlightText(description, query);
    }
    return description;
  };

  return (
    <div className={classNames("col-12", styles.serviceCol)}>
      <div className="row">
        <div className="col-12 col-md-4 my-auto">
          {lottieFile && (
            <Link href={`/services/${id}`}>
              <a>
                <div className="lottie-wrapper">
                  <div className="lottie-bg"></div>
                  <Lottie
                    options={{
                      loop: true,
                      autoplay: true,
                      animationData: lottieFile.component || undefined,
                      rendererSettings: {
                        preserveAspectRatio: "xMidYMid slice",
                      },
                    }}
                    width={"100%"}
                    height={customSize ? lottieFile.size[1] : undefined}
                  />
                </div>
              </a>
            </Link>
          )}
        </div>
        <div className="col-12 col-md-8">
          <div
            className={classNames("d-flex flex-column", styles.serviceTitle)}
          >
            <Link href={`/services/${id}`}>
              <a>
                <h5
                  className="mt-auto text-darken-blue"
                  dangerouslySetInnerHTML={{ __html: renderTitle() }}
                />
              </a>
            </Link>
          </div>
          <p dangerouslySetInnerHTML={{ __html: renderDescription() }} />
        </div>
      </div>
    </div>
  );
};

export default ServiceCardHorizontal;
